import { map as _map } from 'lodash-es';
import { useState, useCallback, Fragment } from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StarIcon from '@mui/icons-material/Star';
import CancelIcon from '@mui/icons-material/Cancel';

const useStyles = makeStyles()((theme) => ({
  button: {
    '& > span:first-of-type': {
      // paddingRight: theme.spacing(0.5),
    },
  },
  buttonValue: {
    display: 'flex',
    alignItems: 'center',
  },
  rsvpIcon: {
    marginRight: theme.spacing(0.5)
  },
}));

const options = {
  GOING: 'Going',
  INTERESTED: 'Interested',
  NOT_GOING: 'Not Going',
};

type Props = {
  value?: string;
  onChange: (...args: unknown[]) => void;
};

const RsvpDropdown = ({ value, onChange }: Props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { classes } = useStyles();

  const handleOpen = useCallback((e) => setAnchorEl(e.currentTarget), []);
  const handleClose = useCallback(() => setAnchorEl(null), []);
  const handleItemClick = useCallback((newValue) => {
    onChange(newValue);
    handleClose();
  }, [onChange, handleClose]);

  return (
    <Fragment>
      <Button
        aria-controls="rsvp-dropdown"
        aria-haspopup="true"
        onClick={handleOpen}
        className={classes.button}
        variant="outlined"
        color="primary"
        fullWidth
      >
        <span className={classes.buttonValue}>
          {!value ? 'RSVP' : (
            <Fragment>
              {value === 'GOING' && (
                <CheckCircleIcon fontSize="small" className={classes.rsvpIcon} />
              )}
              {value === 'INTERESTED' && (
                <StarIcon fontSize="small" className={classes.rsvpIcon} />
              )}
              {value === 'NOT_GOING' && (
                <CancelIcon fontSize="small" className={classes.rsvpIcon} />
              )}
              {options[value]}
            </Fragment>
          )}
        </span>
        <ArrowDropDownIcon />
      </Button>
      <Menu
        id="rsvp-dropdown"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {_map(options, (label, value) => (
          <MenuItem value={value} onClick={() => handleItemClick(value)} key={value}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </Fragment>
  );
};

export default RsvpDropdown;
